import Header from '@components/Header';
import { AppScreen } from '@stackflow/plugin-basic-ui';
import { ActivityComponentType, useStepFlow } from '@stackflow/react';
import { useTranslation } from 'react-i18next';

import InquiryLogs from './components/InquiryLogs';
import InquiryTabHeader from './components/InquiryTabHeader';
import InquiryWriteForm from './components/InquiryWriteForm';

interface Params {
    type: 'READ' | 'WRITE';
}

declare module '@stackflow/config' {
    interface Register {
        InquiryActivity: Params;
    }
}

const InquiryActivity: ActivityComponentType<'InquiryActivity'> = ({ params }) => {
    const { t } = useTranslation('inquiry');
    const { type } = params;
    const { replaceStep } = useStepFlow('InquiryActivity');
    return (
        <AppScreen>
            <Header title={t('header.title')} />
            <InquiryTabHeader type={type} />
            {type === 'WRITE' && (<InquiryWriteForm/>)}
            {type === 'READ' && (<InquiryLogs/>)}
        </AppScreen>
    );
};

export default InquiryActivity;
